module.exports = __webpack_public_path__ + "img/on_normal.07bc5d1c.png";